import React from "react";

export const OfflineEmptyState: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <img
        src="/nokosha-fox-icon.png"
        alt="Nokosha fox"
        className="mb-6 h-24 w-24"
      />
      <h1 className="mb-2 text-xl font-semibold text-foreground">
        We need to get your subscriptions first
      </h1>
      <p className="max-w-sm text-muted-foreground">
        Connect to the internet and open Nokosha — your subscriptions will be
        available offline after that.
      </p>
    </div>
  );
};
